var SENTRY_RELEASE;SENTRY_RELEASE={name: "paperzilla", version: "1.0.0"};